export default {"src":"/_next/static/media/calendar-blank.2369450e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};